import React from 'react'
import { iconName, colour } from '../Icon/types'
import style from './DisabledIcon.module.scss'
import Icon from '../Icon'
import { DisabledIconProps } from './types'
import classnames from 'classnames'

const DisabledIcon: React.FC<DisabledIconProps> = ({ size = 's' }) => {

  const classes = classnames(
    style['disabled-icon'], {
      [style['disabled-icon--xs']]: size === 'xs'
    }
  )

  return <div className={classes}>
    <Icon
      name={iconName.disabledInput}
      colour={colour.danger}
    />
  </div>

}

export default DisabledIcon
